import { connect } from 'react-redux'
import { PuzzleViewer } from '../components'
import * as actions from '../../../actions'
import * as api from '../../../actions/api'
import { boardType } from '../../../constants'

const mapStateToProps = (state, ownProps) => {
  const { records } = state.puzzleListCard
  const { comment, isAppendedBoard, openConfirmDialog, confirmType, confirmParams, deleted, ready } = state.puzzleViewer
  const { user, isAuthStateChange, auth0 } = state.authentication
  const { language } = state.user
  var bid, record

  if (state.puzzleViewer.record) {
    record = state.puzzleViewer.record
  }
  else {
    record = records.find((rc) => rc.id === ownProps.match.params.id)
  }

  bid = state.renjuBoardCards.cards.findIndex((card) => {
    return card.type === boardType.PUZZLE_VIEWER &&
           card.puzzleInfo.puzzleId === ownProps.match.params.id
  })
  return ({
    id: ownProps.match.params.id,
    auth0,
    user,
    isAuthStateChange,
    records,
    record,
    comment,
    isAppendedBoard,
    bid,
    openConfirmDialog,
    confirmType,
    confirmParams,
    deleted,
    ready,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  var record
  return ({
    init: (records, isChangedAuth = false) => {
      var urlProps = {}
      record = records.find(record => record.id === ownProps.match.params.id)
      if (isChangedAuth === false) {
        Object.keys(ownProps).forEach((key) => {
          if (key.match(/v|md|op|mv|pb|pw|tr|rc|an|mc|mk|tl|bp|wp|gr|pt|lv|moves/)) {
            urlProps[key] = ownProps[key]
          }
        })
        if (Object.keys(urlProps).length > 0) {
          urlProps.id = ownProps.match.params.id
          dispatch(actions.puzzleViewer.open(urlProps, false, true))
        }
        else if (record) {
          dispatch(actions.puzzleViewer.open(record, false))
        }
      }
      dispatch(actions.puzzleViewer.requestSelectPuzzle())
      dispatch(api.puzzle.select(
        { id: ownProps.match.params.id, own: true },
        (response) => {
          dispatch(actions.puzzleViewer.responseSelectPuzzle(response))
        }
      ))
    },
    handleClickTag: () => {
      dispatch(actions.puzzleHome.reset())
    },
    handleClickThumbUp: () => {
      dispatch(api.puzzle.selectedGood(ownProps.match.params.id))
    },
    handleClickThumbDown: () => {
      dispatch(api.puzzle.selectedBad(ownProps.match.params.id))
    },
    handleAnswer: (record, bid) => () => {
      dispatch(actions.controlButtons.stopPlay(bid))
      dispatch(actions.puzzleViewer.open(record, true))
      dispatch(actions.controlButtons.startPlay(bid))
    },
    commentProps: {
      handleTextChange: (name) => (event) => {
        dispatch(actions.puzzleViewer.changedText(name, event.target.value))
      },
      handleCheckboxChange: (name) => (event) => {
        dispatch(actions.puzzleViewer.changedCheckbox(name, event.target.checked))
      },
      handleClickComment: (comment, isAppendedBoard, bid) => () => {
        dispatch(actions.puzzleViewer.changedText('comment', ''))
        dispatch(api.puzzle.addComment(ownProps.match.params.id ,comment, isAppendedBoard, bid))
      },
      handleClickOpenBoard: (index, openBoard) => () => {
        if (openBoard) {
          dispatch(actions.puzzleViewer.comment.openBoard(index))
        }
        else {
          dispatch(actions.puzzleViewer.comment.closeBoard(index))
        }
      },
    },
    confirmDialogProps: {
      handleOpen: (confirmType, confirmParams) => () => {
        dispatch(actions.puzzleViewer.confirmDialog.open(confirmType, confirmParams))
      },
      handleClose: () => {
        dispatch(actions.puzzleViewer.confirmDialog.close())
      },
      handleDeletePuzzle: (params) => () => {
        dispatch(api.puzzle.delete(params.id))
        dispatch(actions.puzzleViewer.confirmDialog.close())
      },
      handleDeleteComment: (params) => () => {
        dispatch(api.puzzle.deleteComment(ownProps.match.params.id, params.commentId))
        dispatch(actions.puzzleViewer.confirmDialog.close())
      },
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PuzzleViewer)


// WEBPACK FOOTER //
// ./src/Pages/Puzzle/containers/PuzzleViewer.js